import React, { useEffect } from "react";
import { Form, Input, Row, Col } from "antd";

const CompanyOdsEquipment = ({ equipmentDetails }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (equipmentDetails) {
      form.setFieldsValue(equipmentDetails);
    }
  }, [equipmentDetails, form]);

  return (
    <div className="white-container">
      <h3 className="section-title">ODS Equipment Log</h3>

      <Form layout="vertical" form={form} disabled>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Equipment Name" name="equipment_name">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Location On Board" name="location_on_board">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Make Type" name="make_type">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Year Of Installation" name="year_of_installation">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Refrigerant Type" name="refrigerant_type">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Refrigerant Quantity (Kgs)"
              name="refrigerant_quantity_kgs"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Oil Quantity" name="oil_quantity">
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CompanyOdsEquipment;
